import type { BuildPipelineSnapshot } from '@djgg/creations';
import { LEGACY_BUILD_PIPELINE_REF } from '@djgg/creations';

// Historical receipts retain their original recipe label after editing retires.
export function pipelineLabel(snapshot?: BuildPipelineSnapshot): string {
  if (!snapshot) return `Current pipeline · revision ${LEGACY_BUILD_PIPELINE_REF.revision}`;
  const stage = snapshot.stage === 'prototype' ? 'coded prototype' : snapshot.stage === 'artwork' ? 'artwork' : 'full build';
  return `${snapshot.name} · revision ${snapshot.revision} · ${stage}`;
}
